import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

interface PhoneInputFieldProps {
  value: string;
  onChange: (phone: string, countryCode: string) => void;
}

const PhoneInputField: React.FC<PhoneInputFieldProps> = ({ value, onChange }) => {
  return (
    <div className="phone-input-wrapper">
      <PhoneInput
        country={'us'}
        value={value}
        onChange={(phone, data: any) => {
          onChange(phone, data?.dialCode || '');
        }}
        inputStyle={{
          width: '100%',
          height: '56px',
          backgroundColor: '#F5F5F5',
          border: 'none',
          borderRadius: '12px',
          fontSize: '14px',
          color: '#111827',
          paddingLeft: '58px',
        }}
        buttonStyle={{
          backgroundColor: '#F5F5F5',
          border: 'none',
          borderRadius: '12px 0 0 12px',
          paddingLeft: '12px',
        }}
        dropdownStyle={{
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          border: 'none',
          maxHeight: '250px',
        }}
        searchStyle={{
          borderRadius: '8px',
          border: '1px solid #E5E7EB',
          fontSize: '14px',
        }}
        enableSearch
        searchPlaceholder="Search country..."
        inputProps={{
          required: true,
        }}
      />
      <style>{`
        .phone-input-wrapper .react-tel-input .form-control:focus {
          box-shadow: 0 0 0 2px rgba(57, 55, 127, 0.3);
        }
        .phone-input-wrapper .react-tel-input .selected-flag:hover,
        .phone-input-wrapper .react-tel-input .selected-flag:focus {
          background-color: #EBEBEB !important;
        }
      `}</style>
    </div>
  );
};

export default PhoneInputField;
